export default "__VITE_ASSET__874129e2__"